import React from 'react'
import ReactDOM from 'react-dom'
import { unregister } from './registerServiceWorker';
import './index.css'

// redux 
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import reducer from './reducers'

import AppRouter from './routes'
import injectTapEventPlugin from 'react-tap-event-plugin'

unregister();

injectTapEventPlugin()

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, 
  compose(
    applyMiddleware(sagaMiddleware), 
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
)

sagaMiddleware.run(rootSaga)

ReactDOM.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
  document.getElementById('root')
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js